import { CardMedia, useMediaQuery } from '@mui/material';
import DashboardImage from 'assett/icons/dashboard_image.svg';
import useDevice from 'hooks/DesktopDevice.hook';
import { useLogout } from 'hooks/login.hook';
import { useEffect, useMemo, useState } from 'react';
import { Box, Button, Stack } from 'styles';
import { theme } from 'styles/theme/ThemeStyle';
import { TRANSLATION_KEYS } from 'utils/constants';
import { useTranslation } from 'utils/translations';
import DashboardMenu from './menu/DashboardMenu.component';

interface Props {
	className?: string;
}

const DashboardPage: React.FC<Props> = () => {
	const { isDesktop } = useDevice();
	const tablet = useMediaQuery(theme.breakpoints.down('lg'));
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: TRANSLATION_KEYS.CLIENT_LABELS,
	});

	const [screenWidth, setScreenWidth] = useState(window.innerWidth);

	const hiddenImage = useMemo(() => {
		if (screenWidth < 1560) {
			return true;
		}
		return false;
	}, [screenWidth]);

	const calculateWidth = () => {
		if (screenWidth < 1560 && screenWidth > 1024) {
			return '80%';
		}
		return '100%';
	};

	const handleLogout = useLogout();

	useEffect(() => {
		const updateDimension = () => {
			setScreenWidth(window.innerWidth);
		};
		window.addEventListener('resize', updateDimension);

		return () => {
			window.removeEventListener('resize', updateDimension);
		};
	}, [screenWidth]);

	return (
		<Stack direction={'row'} justifyContent={'space-between'} mt={2}>
			<Stack
				width={{
					sm: !hiddenImage ? '60%' : calculateWidth(),
					lg: '58%',
				}}
				justifyContent={'space-between'}
				rowGap={!!isDesktop ? '70px' : '30px'}
				sx={{
					overflow: 'auto',
					overflowX: 'hidden',
				}}
				gap={'41px'}
			>
				<DashboardMenu />
				<Stack
					direction="row"
					gap={!!tablet ? '18px' : '30px'}
					justifyContent="space-between"
					alignItems="center"
				>
					<Box width="100%">
						<Button variant="contained" onClick={handleLogout}>
							{tClientLabels('dashboard.buttons.logout')}
						</Button>
					</Box>
				</Stack>
			</Stack>
			{!hiddenImage && (
				<Stack
					alignSelf={'flex-end'}
					maxWidth={{ lg: '556px' }}
					maxHeight={{ lg: '430px' }}
					width={!!tablet ? '30%' : 'auto'}
				>
					<CardMedia
						component="img"
						alt={`${tClientLabels('dashboard.image.alt')}`}
						image={DashboardImage}
					/>
				</Stack>
			)}
		</Stack>
	);
};

export default DashboardPage;
